const getDefaultState = () => ({
  mode: 'add',
  jobId: null,
  locked: true,
  client: {
    data: {
      name: '',
      address: '',
      city: '',
      phone: '',
    },
    isValid: false,
  },
  project: {
    data: {
      name: '',
      projectNumber: '',
      laborType: '',
      validityDate: '',
    },
    isValid: false,
  },
  frais: {
    data: {
      material: {
        admin: 0,
        profit: 0,
        adjustment: 0,
      },
      labor: {
        admin: 0,
        profit: 0,
        adjustment: 0,
      },
      subcontract: {
        admin: 0,
        profit: 0,
        adjustment: 0,
      },
    },
  },
  totalMaterialCost: 0,
  totalLaborCost: 0,
  totalSubcontractingCost: 0,
  isUpdatable: false,
});

export default {
  state: getDefaultState(),
  getters: {
    getAll: state => state,
    getMode: state => state.mode,
    getJobId: state => state.jobId,
    getLocked: state => state.locked,
    clientInfo: state => state.client.data,
    clientValidity: state => state.client.isValid,
    projectInfo: state => state.project.data,
    projectValidity: state => state.project.isValid,
    getTotalMaterialCost: state => state.totalMaterialCost,
    getTotalLaborCost: state => state.totalLaborCost,
    getTotalSubcontractingCost: state => state.totalSubcontractingCost,
    getFrais: state => state.frais.data,
    getIsUpdatable: state => state.isUpdatable,
  },
  actions: {
    updateJobId({ commit }, payload) {
      commit('UPDATE_JOB_ID', payload);
    },
    updateMode({ commit }, payload) {
      commit('UPDATE_MODE', payload);
    },
    updateClient({ commit }, payload) {
      commit('UPDATE_CLIENT_INFO', payload.data);
      commit('UPDATE_CLIENT_VALIDITY', payload.isValid);
    },
    updateProject({ commit }, payload) {
      commit('UPDATE_PROJECT_INFO', payload.data);
      commit('UPDATE_PROJECT_VALIDITY', payload.isValid);
    },
    updateTotalMaterialCost({ commit }, payload) {
      commit('UPDATE_TOTAL_MATERIAL_COST', payload);
    },
    updateTotalLaborCost({ commit }, payload) {
      commit('UPDATE_TOTAL_LABOR_COST', payload);
    },
    updateTotalSubcontractingCost({ commit }, payload) {
      commit('UPDATE_TOTAL_SUBCONTRACTING_COST', payload);
    },
    updateAllTotalCost({ commit }, payload) {
      commit('UPDATE_ALL_TOTAL_COST', payload);
    },
    updateLocked({ commit }, payload) {
      commit('UPDATE_LOCKED', payload);
    },
    updateFrais({ commit }, payload) {
      commit('UPDATE_FRAIS', payload);
    },
    updateIsUpdatable({ commit }, payload) {
      commit('UPDATE_IS_UPDATABLE', payload);
    },
    reset({ commit }) {
      commit('RESET');
    },
  },
  mutations: {
    UPDATE_JOB_ID(state, payload) {
      state.jobId = payload;
    },
    UPDATE_LOCKED(state, payload) {
      state.locked = payload;
    },
    UPDATE_MODE(state, payload) {
      state.mode = payload;
    },
    UPDATE_CLIENT_INFO(state, payload) {
      state.client.data = payload;
    },
    UPDATE_CLIENT_VALIDITY(state, payload) {
      state.client.isValid = payload;
    },
    UPDATE_PROJECT_INFO(state, payload) {
      state.project.data = payload;
    },
    UPDATE_PROJECT_VALIDITY(state, payload) {
      state.project.isValid = payload;
    },
    UPDATE_TOTAL_MATERIAL_COST(state, payload) {
      state.totalMaterialCost = payload;
    },
    UPDATE_TOTAL_LABOR_COST(state, payload) {
      state.totalLaborCost = payload;
    },
    UPDATE_TOTAL_SUBCONTRACTING_COST(state, payload) {
      state.totalSubcontractingCost = payload;
    },
    UPDATE_ALL_TOTAL_COST(state, payload) {
      state.totalMaterialCost = payload.totalMaterialCost;
      state.totalLaborCost = payload.totalLaborCost;
      state.totalSubcontractingCost = payload.totalSubcontractingCost;
    },
    UPDATE_FRAIS(state, payload) {
      state.frais.data = payload;
    },
    UPDATE_IS_UPDATABLE(state, payload) {
      state.isUpdatable = payload;
    },
    RESET(state) {
      Object.assign(state, getDefaultState());
    },
  },
};
